import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { LoaderIcon, XIcon } from "lucide-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { MdOutlineOpenInNew } from "react-icons/md";
import InputMask from "react-input-mask";
import { config } from "../../Config";
import { useDevice } from "../../hooks/device/useDevice";
import { listDistribuidoras, simularEconomia } from "../../page/api/simulador";
import AppButton from "../button/AppButton";
import ModaRedirect from "../simulador-economia/_components/ModaRedirect";
import { Button } from "../ui/button";
import { Checkbox } from "../ui/checkbox";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export default function SimuladorEconomiaVD() {
  const isMobile = window && window.innerWidth < 768;
  const device = useDevice();

  const [openModalRedirectAquisition, setOpenModalRedirectAquisition] = useState(false);
  const [openModalRedirectLogin, setOpenModalRedirectLogin] = useState(false);
  const [calculoNaoFinalizado, setCalculoNaoFinalizado] = useState(false);
  const [openModalRedirect, setOpenModalRedirect] = useState(false);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [showSimulador, setShowSimulador] = useState(true);
  const [, setIsTimChecked] = useState(false); // Para controlar se já foi verificado
  const [loading, setLoading] = useState(false);
  const [isTim, setIsTim] = useState(false);

  const [showModalNaoTemosOferta, setShowModalNaoTemosOferta] = useState(false);
  const [distribuidoraSelecionada, setDistribuidoraSelecionada] = useState("");
  const [valorEconomiaMensal, setValorEconomiaMensal] = useState(0);
  const [valorEconomiaAnual, setValorEconomiaAnual] = useState(0);
  const [mediaGastoNumerico, setMediaGastoNumerico] = useState(0);
  const [optComunicacao, setOptComunicacao] = useState(true);
  const [distribuidoras, setDistribuidoras] = useState([]);
  const [fingerprint, setFingerprint] = useState({});
  const [mediaGasto, setMediaGasto] = useState("");
  const [urlParams, setUrlParams] = useState(null);
  const [telefone, setTelefone] = useState("");
  const [utm, setUtm] = useState(null);
  const [hash, setHash] = useState("");

  // Use useRef for debounce timer to avoid stale closure issues
  const debounceTimerRef = useRef(null);
  const lastCalculationRef = useRef("");

  const isFormValid = telefone && telefone.length === 11 && distribuidoraSelecionada && mediaGastoNumerico > 0;

  const hasEconomyCalculated = valorEconomiaMensal > 0;
  const canSubmit = isFormValid && hasEconomyCalculated && optComunicacao;

  // Função para converter string monetária para número
  const parseMoneyToNumber = moneyString => {
    if (!moneyString) return 0;
    return Number.parseFloat(
      moneyString
        .replace(/[R$\s]/g, "")
        .replace(/\./g, "")
        .replace(",", ".")
    );
  };

  // Função para formatar número para moeda
  // const formatNumberToMoney = (number) => {
  //   if (!number) return "";
  //   return new Intl.NumberFormat("pt-BR", {
  //     style: "currency",
  //     currency: "BRL",
  //   }).format(number);
  // };

  // Função para formatar valor monetário em tempo real
  const formatCurrencyInput = value => {
    // Remove tudo que não é dígito
    const numericValue = value.replace(/\D/g, "");

    if (!numericValue) return "";

    // Converte para número e divide por 100 para ter os centavos
    const number = Number.parseInt(numericValue) / 100;

    // Formata como moeda brasileira
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL"
    }).format(number);
  };

  useEffect(() => {
    const fetchFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();

      setFingerprint({
        idVisitor: result.visitorId,
        componentes: {
          dateTimeLocale: result.components.dateTimeLocale,
          platform: result.components.platform,
          vendor: result.components.vendor,
          vendorFlavors: result.components.vendorFlavors,
          timezone: result.components.timezone
        }
      });
    };

    fetchFingerprint();
  }, []);

  useEffect(() => {
    async function fetchDistribuidoras() {
      try {
        const response = await listDistribuidoras();
        setDistribuidoras(response.entities || []);
      } catch (error) {
        console.error("Erro ao carregar distribuidoras:", error);
      }
    }

    fetchDistribuidoras();
  }, []);

  useEffect(() => {
    const utm = {
      utmId: getQueryParams("utm_id"),
      utmSource: getQueryParams("utm_source"),
      UtmMedium: getQueryParams("utm_medium"),
      UtmCampaign: getQueryParams("utm_campaign"),
      UtmSourcePlatform: getQueryParams("utm_source_platform"),
      UtmTerm: getQueryParams("utm_term"),
      UtmContent: getQueryParams("utm_content")
    };
    setUtm(utm);
  }, []);

  useEffect(() => {
    const urlParams = `utm_source=${utm?.utmSource}&utm_medium=${utm?.UtmMedium}&utm_campaign=${utm?.UtmCampaign}&utm_id=${utm?.utmId}`;
    if (utm?.utmSource) {
      setUrlParams(urlParams);
    } else {
      setUrlParams(null);
    }
  }, [utm]);

  const getQueryParams = paramName => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(paramName);
  };

  const handleTelefoneChange = value => {
    setTelefone(value.replace(/[^0-9]/g, ""));
  };

  const handleMediaGastoChange = value => {
    const formattedValue = formatCurrencyInput(value);
    const numericValue = parseMoneyToNumber(formattedValue);

    setMediaGastoNumerico(numericValue);
    setMediaGasto(formattedValue);
  };

  const handleRedirectToLogin = () => {
    const url = `${config.url.urlPortalLogin}`;
    window.location.href = url;
    setOpenModalRedirectLogin(false);
  };

  const handleResetCalculadora = () => {
    setLoading(false);
    setDistribuidoraSelecionada("");
    setIsTimChecked(false);
    setIsTim(false);
    setMediaGasto(0);
    setMediaGastoNumerico(0);
    setValorEconomiaMensal(0);
    setLoadingPreview(false);
    setTelefone("");
    setOptComunicacao(true);
  };

  const handleSimulateEconomy = useCallback(
    async (isPreview = false) => {
      try {
        if (!isFormValid) return;

        if (isPreview) {
          setLoadingPreview(true);
        } else {
          setLoading(true);
        }

        const response = await simularEconomia({
          idDistribuidora: distribuidoraSelecionada.toString(),
          valorConsumo: mediaGastoNumerico,
          origem: 6,
          telefone,
          utm,
          fingerprintIdVisitor: fingerprint ? fingerprint.idVisitor : "",
          fingerprintComponentes: fingerprint ? fingerprint.componentes : "",
          fingerprintDevice: device,
          infoExtra: {
            optComunicacao
          }
        });

        if (response && response.entities) {
          const data = response.entities;

          if (mediaGastoNumerico < 200) {
            setShowModalNaoTemosOferta(true);
            handleResetCalculadora();
            return;
          }

          // Marcar que já foi verificado se é TIM ou não
          setIsTimChecked(true);

          if (response?.entities?.plano === 0 && response?.entities?.mensagens !== "N/A") {
            setCalculoNaoFinalizado(true);
            setLoadingPreview(false);
            setValorEconomiaAnual(0);
            setLoading(false);
            return;
          }

          if (data.isTim) {
            // Atualiza os valores de economia
            const economiaMensal = Number(data.mes) || 0;
            const economiaAnual = Number(data.meses12) || 0;

            setIsTim(true);
            setValorEconomiaMensal(economiaMensal);
            setValorEconomiaAnual(economiaAnual);

            // Só executa as ações de redirecionamento se não for preview
            if (!isPreview) {
              if (data?.situacao === "A") {
                setOpenModalRedirectLogin(true);
              }
              if (data?.situacao !== "A" && data?.situacao !== "1") {
                setOpenModalRedirectAquisition(true);
                setHash(data.hash);
              }
              setHash(data.hash);
              setShowSimulador(false);

              if (config.simulacao.situacao !== data.simulacao) {
                // lead com status diferente da simulação
              }
            }
          } else {
            // Não é TIM - manter valores zerados mas marcar como verificado
            setIsTim(false);
            setValorEconomiaMensal(0);
            setValorEconomiaAnual(0);

            // Esconder simulador mesmo no preview quando não for TIM
            setShowSimulador(false);
          }
        }

        if (isPreview) {
          setLoadingPreview(false);
        } else {
          setLoading(false);
        }
      } catch (err) {
        console.error("Erro ao simular economia:", err);
        if (isPreview) {
          setLoadingPreview(false);
        } else {
          setLoading(false);
        }

        // Se não for preview e der erro, mostrar modal de erro
        if (!isPreview) {
          setCalculoNaoFinalizado(true);
        }
      }
    },
    [device, distribuidoraSelecionada, fingerprint, isFormValid, mediaGastoNumerico, telefone, optComunicacao, utm]
  );

  // Effect para recalcular quando os valores mudarem - evitando recálculos desnecessários
  useEffect(() => {
    // Criar uma chave única para os valores atuais
    const currentValues = `${telefone}-${distribuidoraSelecionada}-${mediaGastoNumerico}`;

    // Se os valores não mudaram, não fazer nada
    if (lastCalculationRef.current === currentValues) {
      return;
    }

    // Clear existing timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    if (!isFormValid) {
      setValorEconomiaMensal(0);
      setValorEconomiaAnual(0);
      setIsTimChecked(false);
      setIsTim(false);
      setShowSimulador(true); // Garantir que o simulador apareça quando inválido
      lastCalculationRef.current = "";
      return;
    }

    // Set new timer
    debounceTimerRef.current = setTimeout(() => {
      // Verificar novamente se os valores ainda são os mesmos
      if (lastCalculationRef.current !== currentValues) {
        lastCalculationRef.current = currentValues;
        handleSimulateEconomy(true); // true indica que é para preview
      }
    }, 1000); // 1 segundo de debounce

    // Cleanup function
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [mediaGastoNumerico, distribuidoraSelecionada, telefone, isFormValid, handleSimulateEconomy]);

  const handleRedirectPortal = useCallback(() => {
    if (!hash) return;
    const baseUrl = `${config.url.urlPortal}/${hash}`;
    const url = urlParams ? `${baseUrl}?${urlParams}` : baseUrl;
    window.location.href = url;
    setOpenModalRedirect(false);
  }, [hash, urlParams]);

  useEffect(() => {
    if (!openModalRedirect) return;

    let current = 3;

    const intervalId = setInterval(() => {
      current -= 1;

      if (current === 0) {
        clearInterval(intervalId);
        handleRedirectPortal();
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [openModalRedirect, handleRedirectPortal]);

  const handleRedirectTim = () => {
    const aEl = document.createElement("a");
    aEl.href =
      "https://tim.com.br/para-voce/planos/portabilidade?_gl=1%2A1hcsr17%2A_gcl_au%2AMTQyNzQxOTcwNy4xNzM3Mzk1ODY5%2A_ga%2AMTcwMDE0Nzg2OS4xNzM3Mzk1ODcx%2A_ga_0SZQLHM90J%2AMTc0MDA1NjcwOS44LjEuMTc0MDA1ODA0MS4xNS4wLjA.&qs=portabilidade";
    aEl.target = "_blank";
    aEl.click();
  };

  const setCookie = (name, value, days) => {
    if (!name || !value) return;
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/; domain=.thopenergy.com.br";
  };

  return (
    <div className='w-full lg:min-w-[35rem] rounded-3xl bg-white p-10 max-sm:px-4'>
      {showSimulador ? (
        <div id='boxSimulador' className='flex flex-col gap-5 justify-center items-center'>
          <h2 className='italic text-center text-neutral-900 text-2xl font-bold'>Simule sua economia</h2>

          <div className='w-full space-y-2'>
            <Label
              htmlFor='telefone'
              className='w-full flex justify-start text-center text-base font-semibold leading-normal'
            >
              DDD + Número celular TIM
            </Label>
            <InputMask
              className='flex h-12 w-full items-center justify-between whitespace-nowrap text-gray-500 rounded-2xl border border-input border-black bg-transparent px-4 py-7 text-lg shadow-sm placeholder:text-muted-foreground focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1'
              mask='(99) 99999-9999'
              placeholder='Digite seu telefone'
              type='tel'
              name='celular'
              id='celular'
              required
              autoComplete='off'
              autoCorrect='off'
              autoCapitalize='off'
              spellCheck='false'
              value={telefone}
              onChange={e => {
                const cleanValue = e.target.value.replace(/[^0-9]/g, "");
                const userId = cleanValue ? `tim_${e.target.value?.replace(/[^0-9]/g, "")}` : null;
                localStorage.setItem("user_id", userId);
                setCookie("timthopenergyuserid", userId, 365);
                handleTelefoneChange(e.target.value);
              }}
            />
          </div>

          <div className='w-full space-y-2'>
            <Label
              htmlFor='distribuidora'
              className='w-full flex justify-start text-center text-base font-semibold leading-normal'
            >
              Distribuidora
            </Label>
            <Select
              onValueChange={value => {
                setDistribuidoraSelecionada(value);
              }}
              value={distribuidoraSelecionada}
              name='distribuidora'
            >
              <SelectTrigger className='w-full'>
                <SelectValue placeholder='Escolha uma opção' />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  {distribuidoras.map((distribuidora, index) => (
                    <SelectItem key={index} value={distribuidora?.idDistribuidora}>
                      {distribuidora?.nomeDistribuidora || "Distribuidora"}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>

          <div className='w-full space-y-2'>
            <div className='space-y-2'>
              <Label
                htmlFor='mediaGasto'
                className='w-full flex justify-start text-center text-base font-semibold leading-normal'
              >
                Insira o valor de sua conta
              </Label>
              <Input
                id='mediaGasto'
                type='text'
                placeholder='R$ 0,00'
                value={mediaGasto}
                onChange={e => handleMediaGastoChange(e.target.value)}
                className='flex h-12 w-full items-center justify-between whitespace-nowrap text-neutral-700 rounded-2xl border border-neutral-400 bg-transparent px-4 py-7 text-lg shadow-sm  focus:outline-none focus:ring-0'
              />
            </div>
          </div>

          {/* Resultado da economia mensal em tempo real - sempre visível */}
          <div className='text-center space-y-2 py-3'>
            {loadingPreview ? (
              <div className='flex flex-col items-center space-y-2'>
                <LoaderIcon size={24} className='animate-spin text-gray-400' />
                <p className='text-lg text-gray-400'>Calculando...</p>
              </div>
            ) : (
              <>
                <p className='text-base font-medium text-gray-600'>Sua economia estimada anual</p>
                <p className='text-3xl font-bold text-gray-600'>
                  {valorEconomiaAnual.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL"
                  })}
                </p>
              </>
            )}
          </div>

          <div className='flex items-center space-x-2'>
            <Checkbox
              id='optComunicacao'
              checked={optComunicacao}
              onCheckedChange={checked => setOptComunicacao(checked === true)}
            />
            <Label htmlFor='optComunicacao' className='text-sm font-normal text-black'>
              Aceito receber comunicações e newsletter da Thopen-TIM
            </Label>
          </div>

          <div className='w-full'>
            <Button
              id='botao-submit'
              variant={canSubmit ? "primary" : "secondary"}
              size='lg'
              disabled={!canSubmit || loading}
              onClick={() => handleSimulateEconomy(false)}
              className={`border-none ${
                canSubmit ? "" : "bg-gray-300 text-gray-500 cursor-not-allowed hover:bg-gray-300 hover:text-gray-500"
              }`}
            >
              {loading ? (
                <>
                  <LoaderIcon size={18} className='mr-2 animate-spin text-white' />
                  Calculando
                </>
              ) : (
                "Quero economizar"
              )}
            </Button>
          </div>
        </div>
      ) : (
        <div id='boxResposta' className='flex flex-col gap-6 justify-center items-center'>
          {isTim && (
            <>
              <div className='w-full flex flex-col justify-center items-center gap-7 my-4'>
                <h4 className='text-center font-bold text-neutral-900 text-2xl leading-[52.80px] mb-2'>
                  Você pode ter
                </h4>

                <div className='w-full flex flex-col justify-center items-center space-y-2'>
                  <p className='font-bold text-3xl md:text-4xl text-color-black'>
                    {valorEconomiaAnual.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL"
                    })}
                  </p>
                  <p>Economia estimada anual</p>
                </div>

                <div className='w-full flex flex-col justify-center items-center space-y-2'>
                  <p className='font-bold text-3xl md:text-4xl text-color-black'>
                    {valorEconomiaMensal.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL"
                    })}
                  </p>
                  <p>Economia estimada mensal</p>
                </div>
              </div>

              <div className='w-full h-px border-b border-gray-200 my-4' />

              <div className='w-full flex max-md:flex-wrap gap-4 items-center justify-center'>
                <AppButton
                  fullWidth
                  variantAcquisition
                  textButton='Economize já'
                  onClick={() => setOpenModalRedirect(true)}
                  id='click_submit'
                />
                <AppButton
                  fullWidth
                  blueVariantborder
                  textButton='Refazer simulação'
                  id='refazer_simulacao'
                  onClick={() => setShowSimulador(true)}
                />
              </div>
            </>
          )}
          {!isTim && (
            <>
              <div className='w-full max-w-[30rem] flex flex-wrap gap-4 items-center justify-center'>
                <div className='w-full flex flex-col justify-center items-center gap-8'>
                  <div className='w-[35px] h-[30px] overflow-hidden'>
                    <img
                      src='/tim/images/logos/logo-tim.png'
                      alt='Logo TIM'
                      className='w-auto h-full object-cover object-left'
                    />
                  </div>
                  <p className='font-bold text-[24px] text-color-black'>
                    Você pode migrar seu número para a TIM! Ganhe 30GB para testar a rede TIM. É grátis e fácil!
                  </p>
                  <p className='text-secondary-text'>Apenas clientes TIM tem elegibilidade para esse benefício.</p>
                  <div className='w-full flex flex-col gap-4 items-center justify-center'>
                    <AppButton
                      fullWidth
                      blueVariantborder
                      textButton='Refazer simulação'
                      id='refazer_simulacao_nao_tim'
                      onClick={() => setShowSimulador(true)}
                    />
                    <AppButton
                      fullWidth
                      variantAcquisition
                      textButton='Eu quero'
                      id='nao_elegivel_tim'
                      onClick={() => handleRedirectTim()}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {/* Modais */}
      <ModaRedirect
        isOpen={openModalRedirectAquisition}
        onClose={() => {
          setOpenModalRedirectAquisition(false);
          setShowSimulador(true);
          setIsTim(false);
        }}
      >
        <div className='flex flex-col h-[100vh] items-start justify-end md:justify-center'>
          <div className='relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6'>
            <button
              className='absolute top-4 right-4 text-black'
              onClick={() => {
                setOpenModalRedirectAquisition(false);
                setShowSimulador(true);
                setIsTim(false);
              }}
              type='button'
            >
              <FaTimes className='w-6 h-6' />
            </button>
            <MdOutlineOpenInNew size={50} color='red' />
            <p className='text-xl text-center font-medium px-4 mt-3 mb-10'>
              Bem-vindo de volta. Vamos redirecioná-lo para a página onde você parou.
            </p>
            <div className='w-full flex justify-center'>
              <AppButton modalVariant fullWidth textButton='Entendi' onClick={() => handleRedirectPortal()} />
            </div>
          </div>
        </div>
      </ModaRedirect>

      {/* Modal de calculo não finalizado */}
      <ModaRedirect
        isOpen={calculoNaoFinalizado}
        onClose={() => {
          setCalculoNaoFinalizado(false);
          setDistribuidoraSelecionada("");
          setMediaGasto(0);
          setTelefone("");
          setOptComunicacao(true);
        }}
      >
        <div className='flex flex-col h-[100vh] items-start justify-end md:justify-center'>
          <div className='relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6'>
            <button
              className='absolute top-4 right-4 text-black'
              onClick={() => {
                setCalculoNaoFinalizado(false);
                setDistribuidoraSelecionada("");
                setMediaGasto(0);
                setTelefone("");
                setOptComunicacao(true);
              }}
              type='button'
              aria-label='Close modal'
            >
              <FaTimes className='w-6 h-6' />
            </button>
            <XIcon size={50} className='text-red-500' />
            <p className='text-xl text-center font-medium px-4 mt-3'>Não foi possível realizar a sua simulação.</p>
            <p className='text-base text-center px-4 my-5'>Tente acessar mais tarde</p>

            <div className='w-full flex justify-center'>
              <AppButton
                fullWidth={isMobile}
                textButton='Entendi'
                onClick={() => {
                  setCalculoNaoFinalizado(false);
                  setDistribuidoraSelecionada("");
                  setMediaGasto(0);
                  setTelefone("");
                  setOptComunicacao(true);
                }}
              />
            </div>
          </div>
        </div>
      </ModaRedirect>

      {/* Modal de não temos uma oferta */}
      <ModaRedirect isOpen={showModalNaoTemosOferta}>
        <div className='flex flex-col h-[100vh] items-start justify-end md:justify-center'>
          <div className='relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6'>
            <XIcon size={50} className='text-red-500' />
            <p className='text-xl text-center font-medium px-4 mt-3'>Ainda não temos uma oferta para você.</p>
            <p className='text-base text-center px-4 my-5'>
              O benefício não está disponível para o seu perfil mensal de consumo. Entraremos em contato assim que
              tivermos uma oportunidade.
            </p>
            <div className='w-full flex flex-col justify-center items-center gap-4'>
              <AppButton
                fullWidth
                type='button'
                textButton='Entendi'
                onClick={() => {
                  const aEl = document.createElement("a");
                  aEl.href = config.url.urlSiteThopen;
                  aEl.target = "_blank";
                  aEl.click();
                  setShowModalNaoTemosOferta(false);
                  handleResetCalculadora();
                }}
              />
              <AppButton
                fullWidth
                secondary
                type='button'
                textButton='Refazer simulação'
                onClick={() => {
                  setShowModalNaoTemosOferta(false);
                  handleResetCalculadora();
                }}
              />
            </div>
          </div>
        </div>
      </ModaRedirect>

      <ModaRedirect
        isOpen={openModalRedirectLogin}
        onClose={() => {
          setOpenModalRedirectLogin(false);
          setShowSimulador(true);
          setIsTim(false);
        }}
      >
        <div className='flex flex-col h-[100vh] items-start justify-end md:justify-center'>
          <div className='relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6'>
            <button
              className='absolute top-4 right-4 text-black'
              onClick={() => {
                setOpenModalRedirectLogin(false);
                setShowSimulador(true);
                setIsTim(false);
              }}
              type='button'
            >
              <FaTimes className='w-6 h-6' />
            </button>
            <MdOutlineOpenInNew size={50} color='red' />
            <p className='text-xl text-center font-medium px-4 mt-3 mb-10'>
              Você já está cadastrado. Vamos redirecioná-lo para fazer sua identificação.
            </p>
            <div className='w-full flex justify-center'>
              <AppButton
                modalVariant
                fullWidth={isMobile}
                textButton='Entendi'
                onClick={() => handleRedirectToLogin()}
              />
            </div>
          </div>
        </div>
      </ModaRedirect>

      <ModaRedirect isOpen={openModalRedirect} onClose={() => setOpenModalRedirect(false)}>
        <div className='flex flex-col h-[100vh] items-start justify-end md:justify-center'>
          <div className='relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6'>
            <button className='absolute top-4 right-4 text-black' onClick={() => setOpenModalRedirect(false)}>
              <FaTimes className='w-6 h-6' />
            </button>
            <MdOutlineOpenInNew size={50} color='red' />
            <p className='text-xl text-center font-medium px-4 mt-3 mb-10'>
              Você será direcionado para o portal do nosso parceiro Thopen.
            </p>
          </div>
        </div>
      </ModaRedirect>
    </div>
  );
}
